import { useState } from 'react'
import { Send, Mic, Sparkles } from 'lucide-react'

const suggestions = [
  'Скільки я витратив цього тижня?',
  'Додай витрату 450 грн на каву',
  'Скільки калорій залишилось сьогодні?',
  'Які плани на завтра?',
]

export default function Assistant() {
  const [messages, setMessages] = useState<
    { role: 'user' | 'assistant'; content: string }[]
  >([
    {
      role: 'assistant',
      content:
        'Привіт! Я твій AI-помічник у Plnly. Можу допомогти з фінансами, харчуванням, планами та загальними порадами. Що зробимо?',
    },
  ])
  const [input, setInput] = useState('')

  const send = () => {
    if (!input.trim()) return
    setMessages((m) => [...m, { role: 'user', content: input }])
    // Заглушка відповіді (підключи реальний AI через API)
    setTimeout(() => {
      setMessages((m) => [
        ...m,
        {
          role: 'assistant',
          content:
            'Це демо-відповідь. Підключи Cloudflare Workers AI, Groq або інший провайдер у backend, щоб отримати справжні відповіді.',
        },
      ])
    }, 600)
    setInput('')
  }

  return (
    <div className="flex flex-col h-[calc(100vh-4rem)] md:h-screen max-w-3xl mx-auto">
      <div className="p-4 border-b border-plnly-border">
        <div className="flex items-center gap-2">
          <Sparkles size={20} className="text-violet-400" />
          <h1 className="text-lg font-semibold">AI асистент</h1>
        </div>
      </div>

      <div className="flex-1 overflow-auto p-4 space-y-4">
        {messages.map((msg, i) => (
          <div
            key={i}
            className={`flex ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}
          >
            <div
              className={`max-w-[85%] rounded-2xl px-4 py-2.5 text-sm ${
                msg.role === 'user'
                  ? 'bg-violet-600 text-white'
                  : 'bg-slate-800 text-slate-100'
              }`}
            >
              {msg.content}
            </div>
          </div>
        ))}
      </div>

      {messages.length === 1 && (
        <div className="px-4 pb-2 flex flex-wrap gap-2">
          {suggestions.map((s) => (
            <button
              key={s}
              onClick={() => setInput(s)}
              className="text-xs px-3 py-1.5 rounded-full bg-slate-800 text-slate-300 hover:bg-slate-700 transition-colors"
            >
              {s}
            </button>
          ))}
        </div>
      )}

      <div className="p-4 border-t border-plnly-border">
        <div className="flex items-center gap-2 card p-2">
          <input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && send()}
            placeholder="Напиши або скажи щось..."
            className="flex-1 bg-transparent outline-none text-sm px-2 placeholder:text-slate-500"
          />
          <button className="p-2 rounded-full hover:bg-slate-700 transition-colors">
            <Mic size={18} />
          </button>
          <button
            onClick={send}
            className="p-2.5 rounded-full bg-violet-600 hover:bg-violet-500 transition-colors"
          >
            <Send size={18} />
          </button>
        </div>
      </div>
    </div>
  )
}
